<template>
  <div>
    <div v-if="tag.name" class="row">
      <div>
        <api-header :id="tag.name.trim().replaceAll(' ', '-')" tag="h2">
          {{ tag.name }}
        </api-header>
        <html-text tag="span" :html="tag.description" />
      </div>
    </div>
    <div class="row">
      <available-operations :operations="tag.operations" />
    </div>
    <api-operation-section
      v-for="(operation, index) in tag.operations"
      :key="operation.path + index"
      :operation="operation"
    />
  </div>
</template>

<script setup lang="ts">
import { PropType } from 'vue';
import { TagWithOperations } from '@bifrost-dev-docs-mfe/common/types/apiDocs';
import HtmlText from '@/components/utils/HtmlText.vue';
import ApiHeader from '@/components/api/content/common/ApiHeader.vue';
import ApiOperationSection from '@/components/api/content/operations/ApiOperationSection.vue';
import AvailableOperations from '@/components/api/content/common/AvailableOperations.vue';

defineProps({
  tag: { type: Object as PropType<TagWithOperations>, required: true },
});
</script>
